<template>
    <div class="position-relative e3-time-picker">
        <ButtonPopup
            ref="popup"
            class="w-100"            
            :disabled="disabled"
            button-class="w-100 position-relative"
            popup-class="p-2"
            :popper-options="popperOptions"
            @close="onPopupClose">
            <input
                :id="id"
                ref="input"
                v-model="timeVal"
                :placeholder="label"
                class="form-control"
                :class="{'is-invalid': validation && validation.$error}"
                :disabled="disabled"
                @click.stop
                @blur="onInputBlur"
                @focus="onInputFocus"
                @keydown="onInputKeydown"/>
            <span class="time-icon">
                <ClockOutlineIcon :class="validation && validation.$error ? 'text-danger' : 'text-primary'" size="18"/>
            </span>
            <template #popup>
                <TimePickerPanel
                    ref="panel"
                    :model-value="timeVal"
                    :minutes-step="minutesStep"
                    :disabled="disabled"
                    :reset="reset"
                    @update:modelValue="onPanelInput"/>
            </template>
        </ButtonPopup>
        <ValitationMessages :validation="validation"/>
    </div>
</template>

<script>
import ButtonPopup from '@/common/components/button-popup/ButtonPopup.vue';
import TimePickerPanel from './TimePickerPanel.vue';
import ClockOutlineIcon from '@/common/components/svg-icons/ClockOutlineIcon.vue';

export default {
    name: 'ETimepicker',
    props: {
        id: [String, Number],
        modelValue: {
            type: String,
            default: undefined
        },
        value: { // TODO: Vue3 remove
            type: String,
            default: undefined
        },
        reset: {
            type: Boolean,
            default: false
        },
        minutesStep: {
            type: Number,
            default: 1
        },
        label: {
            type: String,
            default: 'HH:MM'
        },
        validation: Object,
        disabled: Boolean,
        popperOptions: {
            type: Object,
            default: () => ({
                placement: 'bottom-end',
                modifiers: [
                    { name: 'arrow', enabled: false },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 2]
                        }
                    },
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom-start', 'top-end', 'top-start', 'right', 'left']
                        }
                    }
                ]
            })
        }
    },
    data() {
        return {
            inputFocused: false
        };
    },
    computed: {
        boundValue() {
            if (this.modelValue !== undefined) {
                return this.modelValue;
            }
            if (this.value !== undefined) { // TODO: Vue3 remove
                return this.value;
            }
            return '';
        },
        timeVal: {
            get() {
                return this.boundValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value); // TODO: Vue3 remove
            }
        }
    },
    methods: {
        padSingleDigitHour(time) {
            if (time && time.charAt(1) === ':') {
                return `0${time}`;
            }
            return time;
        },
        onInputFocus() {
            this.inputFocused = true;
            if (!this.timeVal) {
                this.timeVal = '12:00';
            }
            const popup = this.$refs.popup;
            if (popup) {
                popup.openPopup();
            }
            this.$emit('focus');
        },
        onInputBlur() {
            this.inputFocused = false;
        },
        onInputKeydown(event) {
            if (event.key !== 'ArrowDown') {
                return;
            }
            const popup = this.$refs.popup;
            if (!popup || !popup.popupVisible) {
                return;
            }
            event.preventDefault();
            this.$nextTick(() => {
                if (this.$refs.panel && typeof this.$refs.panel.focusHours === 'function') {
                    this.$refs.panel.focusHours();
                }
            });
        },
        onPopupClose() {
            const padded = this.padSingleDigitHour(this.timeVal);
            if (padded !== this.timeVal) {
                this.timeVal = padded;
            }
        },
        onPanelInput(value) {
            if (this.inputFocused) {
                return;
            }
            this.timeVal = value.slice(0, 5);
        }
    },
    components: {
        ButtonPopup,
        TimePickerPanel,
        ClockOutlineIcon
    },
    created() {
        if (this.boundValue && this.boundValue.length > 5) {
            this.timeVal = this.boundValue.slice(0, 5);
        }
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

.time-icon {
    position: absolute;
    top: 4px;
    right: 0;
    pointer-events: none;
    padding: 0.375rem 0.55rem;
    line-height: 1;
}

.form-control.is-invalid {
    background-image: none;
    border: 1px solid $danger !important;
}
</style>
